<template>
  <div v-if="gasFeesData.length == 1" class="relative flex h-full w-full items-center justify-center">
    <BaseLoader />
  </div>
  <div v-else class="relative flex flex-1 flex-col h-full">
    <div class="h-1/4 w-full flex flex-row">
      <template v-for="(value, key) in gweiFee">
        <div class="w-1/3 h-full items-center justify-center flex border-r border-gray-800">
          <div class="flex flex-col space-y-1 text-center">
            <span class="text-gray-300 capitalize">{{ key }}</span>
            <span class="text-gray-100 text-sm">{{ decimals(value.gwei, 0, 0) + ' Gwei' }}</span>
          </div>
        </div>
      </template>
    </div>
    <BaseDivider />
    <template v-for="(item, index) in gasFeesData">
      <div class="flex-1 flex w-full h-1/5">
        <template v-for="(row, i) in item" class="w-1/4">
          <div
            class="h-full items-center flex flex-row px-5 border-r-gray-800"
            :class="[
              i != row.length - 1 ? 'border-r border-b' : '',
              i == 0 || index == 0 ? 'font-semibold text-gray-100': 'text-gray-300',
              i == 0 ? 'w-2/5 justify-start' : 'w-1/5 justify-end',
              index == 0 ? 'border-b-gray-700' : 'border-b-gray-800'
            ]"
          >
            <span>{{ row }}</span>
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script setup>
import { decimals } from '@/composeables/filters';
import { ref, onMounted, computed } from 'vue';
import useHttp from '@/composeables/http';

const $http = useHttp();
const gasFees = ref({});

// GAS FEE
onMounted(() => {
  getGasFees();
  setInterval(() => {
    getGasFees();
  }, 60000);
});

const gweiFee = computed(() => {
  return gasFees.value['swap_transaction']?.fees || {};
});

function getGasFees() {
  $http.get('/data/gas_fees').then(response => (gasFees.value = response.data));
}

const gasFeesData = computed(() => {
  let data = [["Action Type", "Standard", "Fast", "Instant"]];

  Object.keys(gasFees.value).forEach(x => {
    const row = gasFees.value[x];
    data.push([
      row.description,
      "$" + decimals(row.fees?.standard?.usd, 2, 2),
      "$" + decimals(row.fees?.fast?.usd, 2, 2),
      "$" + decimals(row.fees?.instant?.usd, 2, 2)
    ]);
  })

  return data;
});
</script>
